// extracted by mini-css-extract-plugin
module.exports = {"score":"Scores-module__score___1NM7J","ratio":"Scores-module__ratio___3sjYg","points":"Scores-module__points___2zuoO","chart":"Scores-module__chart___c5Vjv"};